import { merge as _merge } from 'lodash'
import br from 'core/translations/br'

export default _merge(br, {
  serverError: {
    INVALID_SERIAL: 'Código inválido: deve ter 18 dígitos.',
    PRODUCTION_ORDER_NOT_FOUND: 'Nenhuma ordem de produção encontrada para este código.',
    STYLE_MATERIAL_COLOR_MISMATCH: 'O modelo, parte ou cor do item não corresponde à linha da ordem de produção.',
    SCONNECT_SHIPMENT_FAILED: 'Falha ao enviar a remessa para o S-Connect.'
  },
  otb_outbound: {
    scan_title: 'Escanear código da ordem de produção (18 dígitos)',
    scan_code_label: 'Código',
    select_title: 'Selecionar ordem de produção',
    header_label: 'Ordem de produção',
    pdf_title: 'Etiqueta PDF',
    pdf_downloaded: 'Etiqueta do volume baixada',
    pdf_error: 'Não foi possível gerar ou baixar a etiqueta PDF',
    pdf_parcel_unavailable: 'Volume confirmado, mas não foi possível recuperá-lo para baixar a etiqueta PDF'
  }
})
